export function isVersionBelow(current: string, minimum: string): boolean {
  const currentSegments = parseVersion(current);
  const minimumSegments = parseVersion(minimum);

  if (!currentSegments || !minimumSegments) {
    return false;
  }

  for (let index = 0; index < currentSegments.length; index += 1) {
    const currentSegment = currentSegments[index];
    const minimumSegment = minimumSegments[index];

    if (currentSegment === undefined || minimumSegment === undefined) {
      return false;
    }

    if (currentSegment < minimumSegment) {
      return true;
    }

    if (currentSegment > minimumSegment) {
      return false;
    }
  }

  return false;
}

function parseVersion(version: string): number[] | null {
  if (!/^\d+\.\d+\.\d+$/.test(version)) {
    return null;
  }

  const segments = version.split(".").map(Number);
  return segments.every(Number.isSafeInteger) ? segments : null;
}
